import React from 'react';
import { images } from '../../../Constants/ImageUrls';
import { downloadAppHandler } from '../../../Utils/redirections';
import { BannerHome } from '../../HomePage/HomeBanner/styled';
import {
  AboutusContainer,
  Playstorebtn,
  Superpowercontent,
  Title,
} from './styled';

export default function index() {
  const downloadApp = () => {
    downloadAppHandler();
  };
  return (
    <AboutusContainer>
      <div>
        <Title aboutMylo>About Mylo</Title>
        <Superpowercontent aboutMylo>
          Mylo: Pregnancy &amp; Baby Companion is the best Indian pregnancy and
          parenting app trusted by 10+ lakh moms. It is the #1 trusted guide
          &amp; tracker for women who are expecting, trying to conceive or have
          a baby.Looking for the ideal Indian Pregnancy or parenting app? Let
          Mylo be your solution for when you’re trying to concieve, become
          pregnant &amp; even after delivery for your baby’s care.
        </Superpowercontent>
        <Playstorebtn>
          <img
            onClick={() => downloadApp()}
            src={images.googlePlayIcon}
            alt="googlePlay"
          />
        </Playstorebtn>
      </div>
      <div>
        <Title>Download the App now</Title>
        <BannerHome
          onClick={() => downloadApp()}
          src={images.downloadApp}
          alt=""
          ratio="16/8.8"
        />
      </div>
    </AboutusContainer>
  );
}
